import { mapGetters } from 'vuex'

import getProperty from "@/shared/getProperty.js"

const common = {
  components: {
    
  },
  computed: {
    locale() {
      return this.$i18n.locale()
    },
    oppLocale() {
      if(this.locale == 'en')
        return 'zh';
      else if(this.locale == 'zh')
        return 'en';
      else
        return 'unknown'
    },
  },
  methods: {
    getProperty(obj, prop, defaultValue) {
      var result = defaultValue;
      for(var i = 0; i < prop.length; i++) {
        var d = getProperty(obj, prop[i], defaultValue);
        if(d === defaultValue) {
          
        } else {
          result = d;
          break;
        }
      }
      return result;
    },
  },
}

export default common;
